<template>
  <div>
    <b-table
      :data="schedules"
      :default-sort="[sortField, sortOrder]"
      :loading="loading"
      :row-class="(row) => !getActivate(row) && 'is-ended'"
      backend-sorting
      scrollable
      @sort="onSort"
    >
      <b-table-column
        :width="28"
        field="id"
        header-class="font-medium text-xs"
        label="No."
        v-slot="props"
      >
        <span class="text-sm">{{ props.index + 1 + (currentPage - 1) * currentPerPage }}.</span>
      </b-table-column>
      <b-table-column
        :width="66"
        field="id"
        sortable
        header-class="font-medium text-xs"
        label="例行性ID"
        v-slot="props"
      >
        <span class="text-sm">{{ props.row.id }}</span>
      </b-table-column>
      <b-table-column
        :width="176"
        field="name"
        header-class="font-medium text-xs"
        label="訂購名稱"
        sortable
        v-slot="props"
      >
        <b-tooltip
          :label="props.row.name"
          append-to-body
          type="is-dark"
        >
          <div class="flex items-center max-w-[176px] truncate">
            <i v-if="!getActivate(props.row)" class="icon-order-end mr-4 text-base text-gray-500" />
            <span class="max-w-[176px] text-sm truncate">{{ props.row.name }}</span>
          </div>
        </b-tooltip>
      </b-table-column>
      <b-table-column
        :width="228"
        field="not_created_length"
        header-class="font-medium text-xs"
        label="訂購週期"
        v-slot="props"
      >
        <span class="text-sm">
          {{ props.row.period_format }}
        </span>
      </b-table-column>
      <b-table-column
        :width="128"
        field="start"
        header-class="font-medium text-xs"
        label="週期起始日"
        sortable
        v-slot="props"
      >
        <span class="text-sm">{{ dayjs(props.row.start_time).format('YYYY/MM/DD') }}</span>
      </b-table-column>
      <b-table-column
        :width="128"
        field="end"
        header-class="font-medium text-xs"
        label="週期結束日"
        sortable
        v-slot="props"
      >
        <span class="text-sm">{{ dayjs(props.row.end_time).format('YYYY/MM/DD') }}</span>
      </b-table-column>
      <b-table-column
        field="tag"
        header-class="font-medium text-xs"
        label="訂購標籤"
        :width="228"
        v-slot="props">
        <b-taglist class="my-auto">
          <span
            v-for="tag in props.row.tags"
            :key="`tag-${tag}`"
            class="
              bg-blue-50
              border
              border-blue-100
              last:mr-1
              leading-[22px]
              mr-1
              px-[10px]
              py-[1px]
              rounded-full
              whitespace-nowrap
            "
          >
            {{ tag }}
          </span>
        </b-taglist>
      </b-table-column>
      <b-table-column
        :width="80"
        field="not_created_length"
        header-class="font-medium text-xs"
        label="未公告訂購"
        v-slot="props"
      >
        <span class="text-sm">
          {{ (props.row.total_length || 0) - (props.row.created_length || 0) }}
        </span>
      </b-table-column>
      <b-table-column
        :width="80"
        field="not_created_length"
        header-class="font-medium text-xs"
        label="應公告訂購"
        v-slot="props"
      >
        <span class="text-sm">
          {{ props.row.total_length }}
        </span>
      </b-table-column>
      <b-table-column
        :width="56"
        centered
        field="limit"
        header-class="font-medium text-xs"
        label="訂購限制"
        v-slot="props"
      >
        <span class="text-sm">{{ getLimitation(props.row.limit, props.row.limit_amount) }}</span>
      </b-table-column>
      <b-table-column
        label="操作"
        centered
        field="share"
        header-class="font-medium max-w-[48px] min-w-[48px] text-xs w-12"
        v-slot="props"
      >
        <b-tooltip
          v-if="getActivate(props.row)"
          label="修改設定"
          append-to-body
          type="is-dark"
        >
          <w-button
            class="hover:text-primary-700 text-primary-500"
            type="icon"
            @click="editSchedule(props.row.id)"
          >
            <i class="icon-edit text-base" />
          </w-button>
        </b-tooltip>
        <b-tooltip
          v-else
          label="查看設定"
          append-to-body
          type="is-dark"
        >
          <w-button
            class="hover:text-primary-700 text-primary-500"
            type="icon"
            @click="viewSchedule(props.row.id)"
          >
            <i class="icon-lookup text-base" />
          </w-button>
        </b-tooltip>
      </b-table-column>
      <b-table-column
        centered
        field="copy"
        header-class="font-medium max-w-[48px] min-w-[48px] text-xs w-12"
        label="複製"
        v-slot="props"
      >
        <b-tooltip
          append-to-body
          label="複製"
          type="is-dark"
        >
          <w-button
            class="hover:text-primary-700 text-primary-500"
            type="icon"
            @click="copySchedule(props.row.id)"
          >
            <i class="icon-copy text-base" />
          </w-button>
        </b-tooltip>
      </b-table-column>
      <b-table-column
        centered
        field="stop"
        header-class="font-medium max-w-[48px] min-w-[48px] text-xs w-12"
        label="終止"
        v-slot="props"
      >
        <b-tooltip
          v-if="getActivate(props.row)"
          append-to-body
          label="終止"
          type="is-dark"
        >
          <w-button
            class="hover:text-primary-700 text-primary-500"
            type="icon"
            @click="onScheduleStop(props.row.id)"
          >
            <i class="icon-stop text-base" />
          </w-button>
        </b-tooltip>
      </b-table-column>
      <b-table-column
        centered
        field="delete"
        header-class="font-medium max-w-[48px] min-w-[48px] text-xs w-12"
        label="刪除"
        v-slot="props"
      >
        <b-tooltip
          v-if="!getActivate(props.row)"
          append-to-body
          label="刪除"
          type="is-dark"
        >
          <w-button
            class="hover:text-red-700 text-red-500"
            type="icon"
            @click="onScheduleDelete(props.row.id)"
          >
            <i class="icon-trash text-base" />
          </w-button>
        </b-tooltip>
      </b-table-column>
      <template #empty>
        <p class="my-12 text-center text-gray-700 text-sm">目前無例行性訂購排程</p>
      </template>
    </b-table>
    <schedule-action-modal
      v-model="openActionModal"
      :loading="isModalLoading"
      :setting="actionSetting"
      @confirm="onModalConfirm()"
    />
  </div>
</template>

<script>
import ScheduleList from './ScheduleList';

export default ScheduleList;
</script>

<style lang="scss" scoped>
@import 'ScheduleList';
</style>
